import logger from '../../utils/logger';

export class LiffTokenService {
  static LIFF_TOKEN_KEY = 'liff_id_token';
  static LIFF_LINKING_FLAG = 'liff_linking_in_progress';

  static setIdToken = (idToken) => {
    try {
      if (idToken) {
        localStorage.setItem(LiffTokenService.LIFF_TOKEN_KEY, idToken);
        logger.info('LIFF ID token stored successfully');
      }
    } catch (error) {
      logger.error('Failed to store LIFF ID token:', error);
    }
  };

  static getIdToken = () => {
    try {
      return localStorage.getItem(LiffTokenService.LIFF_TOKEN_KEY);
    } catch (error) {
      logger.error('Failed to retrieve LIFF ID token:', error);
      return null;
    }
  };

  static removeIdToken = () => {
    try {
      localStorage.removeItem(LiffTokenService.LIFF_TOKEN_KEY);
      localStorage.removeItem(LiffTokenService.LIFF_LINKING_FLAG);
      logger.info('LIFF tokens cleared successfully');
    } catch (error) {
      logger.error('Failed to remove LIFF tokens:', error);
    }
  };

  static hasIdToken = () => {
    return !!LiffTokenService.getIdToken();
  };

  static setLinkingInProgress = (inProgress = true) => {
    try {
      if (inProgress) {
        localStorage.setItem(LiffTokenService.LIFF_LINKING_FLAG, 'true');
      } else {
        localStorage.removeItem(LiffTokenService.LIFF_LINKING_FLAG);
      }
    } catch (error) {
      logger.error('Failed to set linking flag:', error);
    }
  };

  static isLinkingInProgress = () => {
    try {
      return localStorage.getItem(LiffTokenService.LIFF_LINKING_FLAG) === 'true';
    } catch (error) {
      logger.error('Failed to check linking flag:', error);
      return false;
    }
  };

  static clearAll = () => {
    LiffTokenService.removeIdToken();
  };
}